import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "o-grid -push-1" }
const _hoisted_2 = { class: "o-grid-10 sm-:12" }
const _hoisted_3 = { class: "c-events-search u-mb-2xl o-form" }
const _hoisted_4 = { class: "c-events-search__row" }
const _hoisted_5 = { class: "o-form-group c-events-search__row__item" }
const _hoisted_6 = { class: "o-select__wrap o-input__icon" }
const _hoisted_7 = ["value", "innerHTML"]
const _hoisted_8 = { class: "o-form-group c-events-search__row__item" }
const _hoisted_9 = { class: "o-select__wrap o-input__icon" }
const _hoisted_10 = ["value", "innerHTML"]
const _hoisted_11 = { class: "o-form-group c-events-search__row__item" }
const _hoisted_12 = { class: "o-input__icon" }
const _hoisted_13 = { class: "c-events-search__tags" }
const _hoisted_14 = { class: "c-events-search__tags__list u-hide-under-sm" }
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "c-events-search__tags__button" }
const _hoisted_18 = {
  key: 0,
  class: "c-filter__list u-mt-xs"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "c-events-search__results" }
const _hoisted_22 = { class: "c-events-search__results__total" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "c-events-list" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "c-event-card__image-wrap" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "c-event-card__image"
}
const _hoisted_29 = { class: "c-event-card__content" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "o-tags"
}
const _hoisted_33 = {
  key: 2,
  class: "o-tags"
}
const _hoisted_34 = { class: "c-event-card__text" }
const _hoisted_35 = {
  key: 0,
  class: "c-event-card__text__el"
}
const _hoisted_36 = {
  key: 1,
  class: "c-event-card__text__el"
}
const _hoisted_37 = {
  key: 3,
  class: "c-other-results"
}
const _hoisted_38 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Spinner = _resolveComponent("Spinner")
  const _component_Image = _resolveComponent("Image")
  const _component_CalendarMode = _resolveComponent("CalendarMode")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Spinner "),
      _createElementVNode("div", {
        class: _normalizeClass(['o-spinner_wrap', { 'is-loading-listing': $data.loading }])
      }, [
        _createVNode(_component_Spinner)
      ], 2 /* CLASS */),
      _createCommentVNode(" Filters "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" Catégories "),
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              class: "o-label sr-only",
              for: "categorie"
            }, "Catégorie", -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("select", {
                class: "o-select",
                id: "categorie",
                name: "Catégorie",
                onChange: _cache[0] || (_cache[0] = $event => ($options.addFilter('categories', $event.target.value)))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("option", {
                  value: "",
                  disabled: "",
                  selected: ""
                }, "Catégories", -1 /* HOISTED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allCategories, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: category.id,
                    value: category.slug,
                    innerHTML: category.name
                  }, null, 8 /* PROPS */, _hoisted_7))
                }), 128 /* KEYED_FRAGMENT */))
              ], 32 /* NEED_HYDRATION */)
            ])
          ]),
          _createCommentVNode(" Lieux "),
          _createElementVNode("div", _hoisted_8, [
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              class: "o-label sr-only",
              for: "salle"
            }, "Salle", -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("select", {
                class: "o-select",
                id: "salle",
                name: "Salle",
                onChange: _cache[1] || (_cache[1] = $event => ($options.addFilter('salles', $event.target.value)))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", {
                  value: "",
                  disabled: "",
                  selected: ""
                }, "Lieux", -1 /* HOISTED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allSalles, (salle) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: salle.post_name,
                    value: salle.post_name,
                    innerHTML: salle.post_title
                  }, null, 8 /* PROPS */, _hoisted_10))
                }), 128 /* KEYED_FRAGMENT */))
              ], 32 /* NEED_HYDRATION */)
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "c-events-search__row__separator" }, null, -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_11, [
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              class: "o-label sr-only",
              for: "search"
            }, "Recherchez par mot.s-clé.s", -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "o-input",
                type: "search",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.search) = $event)),
                id: "search",
                name: "Recherchez par mot.s-clé.s",
                placeholder: "Recherchez par mot.s-clé.s",
                onKeyup: _cache[3] || (_cache[3] = $event => ($options.updateSearch()))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, $data.search]
              ]),
              _createElementVNode("button", {
                class: "o-input__icon__button",
                onClick: _cache[4] || (_cache[4] = $event => ($options.scrollToResults()))
              }, [
                _createVNode(_component_Image, { id: "search" })
              ])
            ])
          ])
        ]),
        _createCommentVNode(" Tags "),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createCommentVNode(" Types "),
            ($data.viewMode == 'grid')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($data.allTypes, (type) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "o-checkbox__wrap u-hide-under-sm",
                    key: type.term_id
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "o-checkbox",
                      type: "checkbox",
                      id: `type-${type.term_id}`,
                      value: type.slug,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedTypes) = $event)),
                      onChange: _cache[6] || (_cache[6] = $event => ($options.filterSpectacles(true)))
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15), [
                      [_vModelCheckbox, $data.selectedTypes]
                    ]),
                    _createElementVNode("label", {
                      class: "o-checkbox-label",
                      for: `type-${type.term_id}`
                    }, _toDisplayString(type.name), 9 /* TEXT, PROPS */, _hoisted_16)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            ($data.viewMode == 'cal')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = $event => ($data.viewMode = 'grid')),
                  class: "o-button -button-no-bg u-hide-under-sm"
                }, [
                  _cache[17] || (_cache[17] = _createTextVNode(" Programmation ")),
                  _createVNode(_component_Image, { id: "grid" })
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[8] || (_cache[8] = $event => ($data.viewMode = 'cal')),
                  class: "o-button -button-no-bg u-hide-under-sm"
                }, [
                  _cache[18] || (_cache[18] = _createTextVNode(" Calendrier ")),
                  _createVNode(_component_Image, { id: "calendar" })
                ])),
            _createElementVNode("button", {
              class: "o-button -button-no-bg",
              onClick: _cache[9] || (_cache[9] = (...args) => ($options.openAdvancedSearch && $options.openAdvancedSearch(...args))),
              "data-modal": ".js-modal-search",
              "aria-label": "Recherche avancée"
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "o-button__text" }, "Recherche avancée", -1 /* HOISTED */)),
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "sr-only" }, "Recherche avancée", -1 /* HOISTED */)),
              _createVNode(_component_Image, { id: "filter" })
            ])
          ])
        ]),
        ($options.outputFilters().length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.outputFilters(), (tag) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tag.value,
                  class: "c-filter__item"
                }, [
                  _createElementVNode("button", {
                    class: "c-filter__item__close",
                    onClick: $event => ($options.deleteFilter(tag.type, tag.value))
                  }, [
                    _createVNode(_component_Image, { id: "close" })
                  ], 8 /* PROPS */, _hoisted_19),
                  _createElementVNode("span", {
                    class: "c-filter__item__title",
                    innerHTML: tag.name
                  }, null, 8 /* PROPS */, _hoisted_20)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString($data.totalResults) + " résultats", 1 /* TEXT */),
          ($options.outputFilters().length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "o-button -button-show-results -outline",
                onClick: _cache[10] || (_cache[10] = (...args) => ($options.resetFilters && $options.resetFilters(...args))),
                "aria-label": "Réinitialiser la recherche"
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "o-button__text" }, "Réinitialiser la recherche", -1 /* HOISTED */)),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "sr-only" }, "Réinitialiser la recherche", -1 /* HOISTED */)),
                _createVNode(_component_Image, { id: "reload" })
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createCommentVNode(" Listing in Calendar mode "),
      ($data.viewMode == 'cal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_CalendarMode, {
              spectacles: $data.spectacles,
              filterDates: $data.dates,
              onResetDates: $options.resetDates,
              onChangeDates: $options.updateDates
            }, null, 8 /* PROPS */, ["spectacles", "filterDates", "onResetDates", "onChangeDates"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Listing in Default mode "),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.spectacles, (spectacle) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: spectacle.id,
                  class: "c-event-card"
                }, [
                  _createElementVNode("a", {
                    href: spectacle.url,
                    class: "c-event-card__link"
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      (spectacle.image)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: spectacle.image,
                            class: "c-event-card__image"
                          }, null, 8 /* PROPS */, _hoisted_27))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_Image, {
                              id: "event-placeholder",
                              class: "c-event-card__icon -ico-fill"
                            })
                          ])),
                      (spectacle.tag)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(spectacle.tag, (tag, slug) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(['-' + slug, "c-event-card__tag"])
                            }, _toDisplayString(tag), 3 /* TEXT, CLASS */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "c-event-card__artist is-style-lowercase",
                        innerHTML: spectacle.nom_spectacle
                      }, null, 8 /* PROPS */, _hoisted_30),
                      (spectacle.nom_spectacle != spectacle.artiste)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "c-event-card__title",
                            innerHTML: '— '+spectacle.artiste
                          }, null, 8 /* PROPS */, _hoisted_31))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" get spectacle category "),
                      (spectacle.categories.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spectacle.categories, (category) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: category.id,
                                class: "o-tag"
                              }, _toDisplayString($options.format_category_name(category.name)), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : (spectacle.types.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spectacle.types, (type) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: type.id,
                                  class: "o-tag"
                                }, _toDisplayString(type.name), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_34, [
                        (spectacle.representations.length > 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                              _cache[23] || (_cache[23] = _createTextVNode(" Voir toutes les dates ")),
                              _createVNode(_component_Image, {
                                id: "arrow-up-right",
                                class: "c-event-card__icon"
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              _createTextVNode(_toDisplayString(spectacle.representations[0].dates_format.date_visual) + " ", 1 /* TEXT */),
                              _createVNode(_component_Image, {
                                id: "arrow-up-right",
                                class: "c-event-card__icon"
                              })
                            ]))
                      ])
                    ])
                  ], 8 /* PROPS */, _hoisted_25)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
      _createCommentVNode(" Pager "),
      ($data.pagination.pages.length > 1)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 2,
            pagination: $data.pagination
          }, null, 8 /* PROPS */, ["pagination"]))
        : _createCommentVNode("v-if", true),
      ($data.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _cache[24] || (_cache[24] = _createElementVNode("div", {
              class: "o-section-title__wrap u-anim-opacity-up is-inview",
              "data-scroll": "",
              "data-scroll-offset": "10%"
            }, [
              _createElementVNode("h2", { class: "o-title-2 o-section-title" }, "Autres résultats"),
              _createElementVNode("span", {
                class: "o-section-title__line u-anim-clip-from-left is-inview",
                "data-scroll": "",
                "data-scroll-offset": "10%"
              })
            ], -1 /* HOISTED */)),
            _createElementVNode("div", { innerHTML: $data.otherResults }, null, 8 /* PROPS */, _hoisted_38)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}